/* eslint-disable */

/**
 * Toggle the Widget
 */
const $toggleWidget = $('.js-toggle-widget');
$toggleWidget.on('click', function (e) {
  e.preventDefault();
  const $widget = $(this).closest('.filter__widget');
  $(this).next('.filter__widget-content').toggle();
  $widget.toggleClass('filter__widget--is-collapsed');
  $widgetContent.toggle();
});

/**
 * When form value changes, submit the form
 */
$(document).ready(() => {
  $form = $('.js-filter-form');
  $form.on('change', () => {
    $form.submit();
  });
});